<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }} </h1>
        <h2 style="visibility: hidden;opacity:0;"></h2>
      </div>
    </div>

    <div class="md-layout-item _commentList">
      <ElasticList :list="list"></ElasticList>
    </div>
  </div>
</template>

<script>
import ElasticList from "@/components/DynamicForm/ElasticList";
import Page from '@/mixins/Page';

export default {
  components: {
    ElasticList
  },
  mixins: [Page],
  data() {
    return {
      list: {
        hideNewRecordButton: true,
        hideListHeader: true,
        hideActionColumn: true,
        linkRows: false,
        pageTitle: "Comments",
        pageIcon: "comment",
        listQueryId: "searchCommentsCustoms",
        responseFieldName: "searchComments",
        itemActions: [],
        linkConfigs: [
          {
            name: 'username',
            hrefCallback: (column, name, item) => {
              return item.user ? `#/users/${item.user.id}` : '#';
            },
            titleCallback: (column, name, item) => {
              return item.user ? item.user.given_name + ' ' + item.user.family_name : '';
            },
          },
          {
            name: 'sourceName',
            hrefCallback: (column, name, item) => {
              let path = item.source && item.sourceName ? `#/${item.source}/${item.sourceId}#${item.sourceNameId}` : '#'

              if(item.sourceId && item.sourceNameId && item.sourceId === item.sourceNameId){
                  path = `#/${item.source}/${item.sourceId}`
              }
                return path
            },
            titleCallback: (column, name, item) => {
              return item.sourceName ? item.sourceName : '';
            },
          },
        ],
        columns: {
          commentFormatted: { label: "Comment", title: 'commentTitle' },
          username: { label: "User" },
          createdAt: { label: "Created", sortable: true },
          updatedAt: { label: "Updated", sortable: false },
          sourceName: { label: "Source" }
        },
        perPageOptions: [5, 10, 20, 25, 50],
        defaults: {
          sort: 'createdAt',
          sortDir: 'desc',
          perPage: 10,
        },
        fuseSearch: null,
        formatResponse: (data) => {
          let result = [];
          const responseFieldName = 'searchComments';
          const items = this.$reduce(data, 'searchComments.items');
          if (items && items.length) {
            items.forEach((_item) => {
              _item.username = _item.user ? _item.user.given_name + ' ' + _item.user.family_name : _item.owner;
              _item.sourceName = '';
              _item.commentFormatted = _item.comment ? _item.comment.replace(/(<([^>]+)>)/gi, "").substr(0, 180) : '';
              _item.commentTitle = _item.comment ? _item.comment.replace(/(<([^>]+)>)/gi, "") : '';
              if(_item.message){
                //   _item.sourceName = _item.message.subject.replace(/(<([^>]+)>)/gi, "")
                  _item.sourceName = 'Message'
                  _item.sourceNameId = _item.message.id
                  _item.source = 'cases'
                  _item.sourceId = _item.message.messageCaseId
              }
              if(_item.note){
                //   _item.sourceName = _item.note.note.replace(/(<([^>]+)>)/gi, "")
                  _item.sourceName = 'Note'
                  _item.sourceNameId = _item.note.id
                  _item.source = 'cases'
                  _item.sourceId = _item.note.case.id
              }
              if(_item.task){
                //   _item.sourceName = _item.task.subject.replace(/(<([^>]+)>)/gi, "")
                  _item.sourceName = 'Task'
                  _item.sourceNameId = _item.task.id
                  _item.source = 'tasks'
                  _item.sourceId = _item.task.id
              }
              if(_item.parentComment){
                //   _item.sourceName = _item.parentComment.comment.replace(/(<([^>]+)>)/gi, "")
                  _item.sourceName = 'Comment'
                  _item.sourceNameId = _item.parentComment.id                  
                  _item.source = _item.parentComment.task ? 'tasks' : _item.parentComment.service ? 'services' : ''
                  _item.sourceId = _item.parentComment.task ? _item.parentComment.task.id : _item.parentComment.service ? _item.parentComment.service.id : '' 
              }
              if(_item.service && !_item.parentComment){
                //   _item.sourceName = _item.parentComment.comment.replace(/(<([^>]+)>)/gi, "")
                  _item.sourceName = 'Service'
                  _item.sourceNameId = _item.service.id                  
                  _item.source = 'services'
                  _item.sourceId = _item.service.id
              }
              result.push(_item);
            });
          }
          return result;
        }
      },
    };
  },
};
</script>

<style lang="scss">
  ._commentList tbody .md-table-row {
    .md-table-cell:first-child {
      width: 30%;
    }
    .md-table-cell:nth-child(2) {
      width: 20%;
    }
  }
  ._commentList .paginated-table .md-table-cell:last-child .md-table-cell-container, ._commentList .paginated-table .md-table-head:last-child {
    text-align: left!important;
    justify-content: flex-start;
}
</style>
